export default __webpack_public_path__ + "static/media/click-gray.8206863b.svg";